/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'

export default function TeacherHeadItem(props) {
    return (
        <div className={`list-item ${props.active ? "active" : ""}`}>
            <div className="item-avatar">
                <img src={process.env.PUBLIC_URL + "/assets/images/mn_tea_head_" + props.index + ".avif"} alt=''/>
            </div>
            <div className="context">
                <p className="teacher-name">{props.name}</p>
                <h5 className="label-pc">{props.school}, {props.diploma}</h5>
                <p className="text">{props.des}</p>
                <p className="lilian-text">{props.slogan}</p>
            </div>
        </div>
    )
}
